import { Component, Input } from '@angular/core';
import { DEFAULT_LOADING_PAGE_SIZE } from 'src/app/core/app.constants';

@Component({
    selector: 'app-panel-list-group',
    templateUrl: './panel-list-group.component.html',
    standalone: false
})
export class PanelListGroupComponent {
  @Input() icon: string;
  @Input() showHeading: boolean = true;
  @Input() loadingPageSize: number;
  @Input() isLoading: boolean = false;

  getLoadingRange(): number[] {
    return Array(this.getLoadingPageSize()).fill(0).map((x, i) => i);
  }

  private getLoadingPageSize(): number {
    return this.loadingPageSize ?? DEFAULT_LOADING_PAGE_SIZE;
  }
}
